import * as TetherSelect from 'tether-select';

export default {
    select: null,
    TetherSelect: null,
    currentSelect: null,
    async created() {
        this.initSelect();
    },
    mounted() {
        window.addEventListener('resize', this.onResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
    render() {
        return this.$scopedSlots.default({
            registerSelect: this.registerSelect,
        });
    },
    methods: {
        registerSelect({ el }) {
            this.$options.select = el;
            this.initSelect();
        },
        onResize() {
            this.$options.currentSelect.close();
        },
        initSelect() {
            const { select } = this.$options;
            if (!select) return;

            this.$options.currentSelect = new TetherSelect({
                el: select,
                className: 'component-tether-select',
                useNative: false,
            });

            const { currentSelect } = this.$options;

            currentSelect.on('open', this.calculateWidths);
            currentSelect.on('change', (value) => {
                this.$emit('change', value);
            });
        },
        calculateWidths() {
            const { target, drop } = this.$options.currentSelect;

            drop.style.width = `${target.getBoundingClientRect().width}px`;
        },
    },
};
